import React from "react";
import { withRouter } from "us.common/wIthRouter";
import Admin from "us.collection.admin";

interface ICntNonProductionDaysCalendar {}
const Cnt_NonProductionDaysCalendar: React.FC<ICntNonProductionDaysCalendar> = (
  props
) => {
  return (
    <>
      <Admin.Components.NonProductionDays.Calendar {...props} />
    </>
  );
};

export default withRouter(Cnt_NonProductionDaysCalendar);
